import { render, staticRenderFns } from "./LinkRelsList.vue?vue&type=template&id=1ec5a9e0&"
import script from "./LinkRelsList.vue?vue&type=script&lang=js&"
export * from "./LinkRelsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports